module.exports = __webpack_public_path__ + "img/5.193d8b9b.jpg";